import VList from './VList'
import VListItem from './VListItem'

export default {
  VList,
  VListItem
}
